// extracted by mini-css-extract-plugin
export default {"primaryColor":"#227b8b","secondaryColor":"#e9ecef","primaryTextColor":"#757575","warningColor":"#ed6c02"};